import React, {useState} from 'react';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {createRefetchContainer, graphql} from 'react-relay';
import TimeRegBaseLevelWrapper from './TimeRegBaseLevelWrapper';
import {getPhaseRow} from '../rows/PhaseRow';
import {useGenericReportContext} from '../../../saved-report/GenericReportContext';

const TimeRegPhaseRelayWrapper = ({
	relay,
	tableHeader,
	groupings,
	searchQuery,
	viewer,
	intl,
	groupIndex,
	enabledColumns,
	nextLevelProps,
	currency,
	customFieldColumnCount,
	customFieldKeys,
	pageSize,
}) => {
	const {reportId, sharedId} = useGenericReportContext();

	const phases = viewer.reportData.phases.edges?.filter(phase => phase.node.timeRegTotals.totalTimeRegistered > 0);
	const hasNextPage = viewer.reportData.phases.pageInfo.hasNextPage && phases?.length >= pageSize;
	const [modalTasksFetching, setModalTasksFetching] = useState(false);

	const dataRows = phases.map(phase => {
		return {
			...phase.node,
		};
	});

	const data = {rows: dataRows};

	const fetchMore = () => {
		if (!modalTasksFetching) {
			const refetchObject = {};
			setModalTasksFetching(true);
			refetchObject.pageSize = phases.length + pageSize;
			relay.refetch(refetchObject, null, () => setModalTasksFetching(false));
		}
	};

	const phaseRows = () => {
		return getPhaseRow(
			data,
			intl,
			groupIndex,
			searchQuery,
			groupings,
			enabledColumns,
			hasNextPage,
			fetchMore,
			nextLevelProps,
			currency,
			reportId,
			sharedId,
			customFieldColumnCount,
			customFieldKeys
		);
	};

	return groupIndex === 1 ? (
		<TimeRegBaseLevelWrapper
			tableHeader={tableHeader}
			intl={intl}
			enabledColumns={enabledColumns}
			getRows={phaseRows}
			currentLength={phases.length}
			hasNextPage={viewer.reportData.phases.pageInfo.hasNextPage}
			refetch={relay.refetch}
			customFieldColumnCount={customFieldColumnCount}
			pageSize={pageSize}
		/>
	) : (
		phaseRows()
	);
};

const TimeRegPhaseRelayWrapperQuery = graphql`
	query TimeRegPhaseRelayWrapper_Query(
		$searchQuery: TaskSearchQueryType
		$pageSize: Int
		$reportId: String
		$sharedId: String
	) {
		viewer {
			actualPersonId
			component(name: "time_reg_phase_relay_wrapper_v2")
			...TimeRegPhaseRelayWrapper_viewer
				@arguments(searchQuery: $searchQuery, pageSize: $pageSize, reportId: $reportId, sharedId: $sharedId)
		}
	}
`;
export {TimeRegPhaseRelayWrapperQuery};

export default injectIntl(
	withRouter(
		createRefetchContainer(
			TimeRegPhaseRelayWrapper,
			{
				viewer: graphql`
					fragment TimeRegPhaseRelayWrapper_viewer on Viewer
					@argumentDefinitions(
						searchQuery: {type: "TaskSearchQueryType"}
						pageSize: {type: "Int"}
						reportId: {type: "String"}
						sharedId: {type: "String"}
					) {
						reportData(id: $reportId, sharedId: $sharedId) {
							phases(first: $pageSize, searchQuery: $searchQuery)
								@connection(key: "TimeRegReport_phases", filters: ["searchQuery"]) {
								pageInfo {
									endCursor
									hasNextPage
								}
								edges {
									node {
										phaseId
										name
										noPhase
										timeRegTotals {
											totalCost
											totalPrice
											totalTimeRegistered
											totalBillableRegistered
											totalNonBillableRegistered
										}
									}
								}
							}
						}
					}
				`,
			},
			graphql`
				query TimeRegPhaseRelayWrapperRefetchQuery(
					$pageSize: Int
					$searchQuery: TaskSearchQueryType
					$reportId: String
					$sharedId: String
				) {
					viewer {
						...TimeRegPhaseRelayWrapper_viewer
							@arguments(pageSize: $pageSize, searchQuery: $searchQuery, reportId: $reportId, sharedId: $sharedId)
					}
				}
			`
		)
	)
);
